import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
import "../../../../assets/css/tabs.css";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CUSTOMER,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  Message_DATA1,
  Message_DATA,
  Message_DATA3,
  NECESSARY_FIELD,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import Loader from "../../../../components/Loader/Loader";
import { uploadAWS } from "../../../../common/AWSHelper";
import FileInput from "../../../../components/FormControls/FileInput";
import { checkUserPermission } from "../../../../common/UserPermission";
import Customerlisting from "../../../../components/SalesCard/Customerlisting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paymentlisting from "../../../../components/SalesCard/Paymentlisting";
import PurchaseStatement from "../../../../components/Customer/PurchaseStatement";
import { Noimage } from "../../../../common/imagePath";
import CryptoJS from "crypto-js";
import {
  decryptAndConvert,
  decryptAndExtractId,
} from "../../../../common/common";
import ChangePasswordModal from "../../../../components/Modal/ChangePassword";
import { CloudLightning } from "feather-icons-react/build/IconComponents";
import { event } from "jquery";

let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";

const ManageCustomer = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const Location = localStorage.getItem("Location");

  const [protectIdKey, setProtectIdKey] = useState(null);
  const [PasswordModalOpen, setPasswordModalOpen] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldCustomerValues, setCustomFieldCustomerValues] = useState(
    []
  );
  const [phoneNumber, setPhoneNumber] = useState('');
  const [AllowResell, setAllowResell] = useState(false);

  console.log(AllowResell , " AllowResell")

  let location = useLocation();
  // console.log(location.pathname.split("/"), "pageloaction");
  const ComponentURl = location.pathname.split("/")[1] === "customerstatement";
  console.log(ComponentURl, "ComponentURl");

  useEffect(() => {
    // small function created in src/common/common.js
    if (ComponentURl) {
      const searchParams = new URLSearchParams(location.search);
      const cValue = searchParams.has("c") ? searchParams.get("c") : null;
      if (cValue === null || cValue === "") {
        navigate("/404");
        return;
      }
      console.log(cValue, "1022");

      // const decryptedString = decryptAndConvert(cValue);
      const decryptedString = decryptAndExtractId(cValue);
      setProtectIdKey(decryptedString);

      // function decrypt(encryptedText, key) {
      //     let decryptedText = '';
      //     for (let i = 0; i < encryptedText.length; i++) {
      //         let charCode = encryptedText.charCodeAt(i);
      //         if (
      //             (charCode >= 65 && charCode <= 90) ||
      //             (charCode >= 97 && charCode <= 122)
      //         ) {
      //             // Uppercase and lowercase letters
      //             decryptedText += String.fromCharCode(
      //                 ((charCode - 65 - key + 52) % 52) + 65
      //             );
      //         } else if (charCode >= 48 && charCode <= 57) {
      //             // Numeric characters
      //             decryptedText += String.fromCharCode(
      //                 ((charCode - 48 - key + 10) % 10) + 48
      //             );
      //         } else {
      //             decryptedText += encryptedText.charAt(i);
      //         }
      //     }
      //     return decryptedText;
      // }

      // function alphanumericToNumber(alphanumeric) {
      //     const alphanumericValues =
      //         'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      //     let result = 0;

      //     for (let i = 0; i < alphanumeric.length; i++) {
      //         result =
      //             result * 10 +
      //             alphanumericValues.indexOf(alphanumeric.charAt(i));
      //     }

      //     return result;
      // }
      // const key=4;

      //    // Decrypt the encrypted string
      //     const decryptedStringnum = alphanumericToNumber(cValue);
      //     const decryptedString = decrypt(decryptedStringnum.toString(), key);
      //     console.log('Decrypted num: 1232', decryptedStringnum);
      //     console.log('Decrypted: 1232', decryptedString);

      // const originalKey = cValue
      //   .toString()
      //   .replace("%2B", '+')
      //   .replace("%2F", '/')
      //   .replace("%3D", '=');
      // // const originalKey = cValue.toString().replace('4W9E8', '+' ).replace('4R8C6', '/').replace('8E2D5', '=');
      // console.log(config.portalSendIdKey, "1255");
      // console.log(originalKey, "1022");
      // const decrypted2 = CryptoJS.AES.decrypt(
      //   `${originalKey}`,
      //   config.portalSendIdKey
      // );
      // const decryptedData = decrypted2
      //   ? decrypted2.toString(CryptoJS.enc.Utf8)
      //   : null;

      // if (decryptedData === null) {
      //   navigate("/404");
      //   return;
      // }
      // const parseddata = decryptedData ? JSON.parse(decryptedData) : null;

      // console.log(cValue, "cvalue 1255");
      // console.log(parseddata, "1022");

      // if (parseddata?.status !== "ok") {
      //   navigate("/404");
      //   return;
      // }
      // setProtectIdKey(parseddata?.ID);
      // setProtectIdKey(decryptedString);
    }
  }, [location]);

  const [data, setData] = useState([]);
  const [customer, setCustomer] = useState(false);
  const [listingdata, setListingData] = useState(false);
  const [error, setError] = useState(false);
  const [customerdetails, setCustomerDetails] = useState({});
  const [termsDropdown, setTermsDropdown] = useState([]);
  const [formValues, setFormValues] = useState({
    CompanyName: "",
    Title: "",
    FirstName: "",
    LastName: "",
    EMail: "",
    PhoneNumber: "",
    SelectImage: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    Comments: "",
    InternalNotes: "",
    StoreAccountBalance: 0.0,
    CreditLimit: 0,
    Terms: "",
    Account: "",
    OverrideDefaultTaxForSale: false,
    TaxGroup: "",
    TaxId1: 0,
    TaxName1: "",
    TaxPercent1: "",
    TaxId2: 0,
    TaxName2: "",
    TaxPercent2: "",
    Cumulative: false,
    TaxId3: 0,
    TaxName3: "",
    TaxPercent3: "",
    TaxId4: 0,
    TaxName4: "",
    TaxPercent4: "",
    TaxId5: 0,
    TaxName5: "",
    TaxPercent5: "",
    Taxable: true,
    NonTaxCertificateNumber: "",
    MessageToShowWhenAddingCustomerToSale: "",
    AutoEmailReceipt: false,
    REP: "",
    AlternatePhone: "",
    TaxID: 0,
    ElectronicCigaretteId: "",
    Instagram: "",
    TobaccoLicense: "",
    ROUTE: "",
    FileId1: 0,
    File1: "",
    FileId2: 0,
    File2: "",
    FileId3: 0,
    File3: "",
    FileId4: 0,
    File4: "",
    FileId5: 0,
    File5: "",
    RoleTierID: "",
    UserName: "",
    Password: "",
    ParentCustId: 0,
  });

  console.log(formValues, "5435355");

  const [totalRows, setTotalRows] = useState(0);
  const [perPageSize, setperPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectOverrideDefaultTaxForSale, setSelectOverrideDefaultTaxForSale] =
    useState(false);
  const [showMore, setShowMore] = useState(false);
  const [disableCumulative, setDisableCumulative] = useState(false);
  const [selectTaxable, setSelectTaxable] = useState(true);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedTerms, setSelectedTerms] = useState(0);
  const [isecom, setisecom] = useState(false);
  const [passworddeable, setpassworddeable] = useState(0);
  const [quantity, setquantity] = useState(false);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);

  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedRep, setSelectedRep] = useState("");

  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [customFieldsBinding, setCustomFieldsBinding] = useState([]);

  const [selectedCustomFile, setSelectedCustomFile] = useState("");

  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl1, setImageUrl1] = useState(false);
  const [ImageUrl2, setImageUrl2] = useState(false);
  const [ImageUrl3, setImageUrl3] = useState(false);
  const [ImageUrl4, setImageUrl4] = useState(false);
  const [ImageUrl5, setImageUrl5] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [customFileUrl, setCustomFileUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [File1Url, setFile1Url] = useState("");
  const [filedetails, setFileDetails] = useState([]);
  const [File2Url, setFile2Url] = useState("");
  const [selectedFile2, setSelectedFile2] = useState("");
  const [File3Url, setFile3Url] = useState("");
  const [selectedFile3, setSelectedFile3] = useState("");
  const [File4Url, setFile4Url] = useState("");
  const [selectedFile4, setSelectedFile4] = useState("");
  const [File5Url, setFile5Url] = useState("");
  const [selectedFile5, setSelectedFile5] = useState("");
  const [toggle, setToggle] = useState(1);
  const [customerid, setCustomerID] = useState(0);

  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [salesSummary, setSalesSummary] = useState([]);
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [listid, setListId] = useState(0);
  const [generalurl, setGeneralUrl] = useState([]);
  const [quickbookid, setQuickbookid] = useState(0);

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  const [salesTypeID, setSalesTypeID] = useState(0);
  const [managecustomerID, setManageCustomerID] = useState(1);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [customerValue, setCustomerValue] = useState();
  const [payment, setPayment] = useState(false);
  const [taxdropdown, setTaxDropDown] = useState([]);
  const [roletierdropdown, setRoleTierDropDown] = useState([]);
  const [selectedRoleTier, setSelectedRoleTier] = useState(0);
  const [comment, setComment] = useState(false);
  const [internalnotes, setInternalNotes] = useState(false);
  const [contenttype, setContentType] = useState("");
  const [content, setContent] = useState("");
  const [statement, setStatement] = useState(false);
  const [filedata, setfiledata] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [PreviewImage2, setPreviewImage2] = useState(null);
  const [PreviewImage3, setPreviewImage3] = useState(null);
  const [PreviewImage4, setPreviewImage4] = useState(null);
  const [PreviewImage5, setPreviewImage5] = useState(null);
  const [PreviewImage6, setPreviewImage6] = useState(null);
  const [filename, setfilename] = useState("");
  const [eventdatas, seteventdatas] = useState([]);
  const [index, setindex] = useState(0);

  const [isParentCustomer, setisParentCustomer] = useState([]);
  const [selectParentCustomer, setSelectParentCustomer] = useState(0);
  const [subcustomer, setsubcustomer] = useState(0);
  const [isSubCustomer, setIsSubCustomer] = useState(false);
  const [billparentcustomer, setbillparentcustomer] = useState(false);

  const [isLocation, setisLocation] = useState("");

  console.log(selectedRoute, "selectedRoute 0554");
  console.log(selectedRep, "selectedRep 0554");
  console.log(selectedLevel, "selectedLevel 0554");
  const handlePayment = () => {
    setStatement(false);
    setPayment(true);
    setCustomer(false);
    setListingData(false);
    setComment(false);
    setInternalNotes(false);
  };

  const handleStatement = () => {
    setStatement(true);
    setPayment(false);
    setCustomer(false);
    setListingData(false);
    setComment(false);
    setInternalNotes(false);
  };

  const handleNotes = () => {
    setStatement(false);
    setInternalNotes(true);
    setCustomer(false);
    setListingData(false);
    setComment(false);
    setPayment(false);
  };

  const handleCommentAndNotes = (e) => {
    setContentType(e.target.name);
    setContent(e.target.value);
  };

  const commentandnotes = {
    id: paramObject.id,
    content: content,
    contenttype: contenttype,
    loginuserid: Id,
    quickbookid: quickbookid,
  };

  console.log(formValues.ParentCustId, "dddddddddddddddd");

  const handleSubmit1 = () => {
    // console.log( "sonu")
    axios
      .post(
        `${config.customersBaseUrl}/customers/updatecomments`,
        commentandnotes,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/customers");
          navigate(-1);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);

        // backtopreviouspage();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleComment = () => {
    setStatement(false);
    setComment(true);
    setCustomer(false);
    setListingData(false);
    setPayment(false);
    setInternalNotes(false);
  };

  const handleCustomer = (id) => {
    setManageCustomerID(id);
  };

  const handledata = (id) => {
    setStatement(false);
    setCustomer(false);
    setPayment(false);
    setListingData(true);
    setListId(id);
    setComment(false);
    setInternalNotes(false);
  };

  const handleLocationChange = (e) => {
    setSelectedTaxGroup(e.value);
  };

  console.log(isParentCustomer, "isParentCustomer11111111");

  const validationSchema = Yup.object().shape({
    CompanyName: Yup.string().required("Company Name is required"),
    // FirstName: Yup.string().required("First Name is required"),
    // LastName: Yup.string().required("Last Name is required"),
    // EMail: Yup.string().email().required("E-mail is required"),
    // PhoneNumber: Yup.string()
    //   .max(10, "Phone number must be at most 10 digits")
    //   .min(10, "Phone number must be at most 10 digits")
    //   .matches(/^\d+$/, "Phone number must only contain digits"),
    // .required("Phone number is required"),
    // Address1: Yup.string().required("Address 1 is required"),
    // Address2: Yup.string().required("Address 2 is required"),
    // City: Yup.string().required("City is required"),
    // StateProvince: Yup.string().required("State/Province is required"),
    // Zip: Yup.string()
    //   .required("Zip is required")
    //   .min(6, "Zip Code must be at least 6 digits")
    //   .max(6, "Zip Code must be at most 6 digits"),
    // Country: Yup.string().required("Country is required"),
    // AlternatePhone: Yup.number()
    //   .notRequired()
    //   // .matches(/^\d+$/, "Phone number must only contain digits")
    //   // .max(10, "Alternate Phone No. must be at most 10 digits"),
    //   .typeError("Alternate Phone No. must be a number")
    //   .integer("Alternate Phone No. must be an integer")
    //   .test("len", "Alternate Phone No. must be exactly 10 digits", (val) =>
    //     val ? val.toString().length === 10 || val.toString().length === 0 : true
    //   ),

    // TaxPercent1: Yup.number().notRequired(),
    // TaxPercent2: Yup.number().notRequired(),
    // TaxPercent3: Yup.number().notRequired(),
    // TaxPercent4: Yup.number().notRequired(),
    // TaxPercent5: Yup.number().notRequired(),
    // StoreAccountBalance: Yup.number().notRequired(),
    // Account: Yup.string().required("Account Number is required"),
    // CreditLimit: Yup.number().notRequired(),
    // OpeningBalance: Yup.number().required("Opening Balance is required"),
    ...(isecom
      ? {
          RoleTierID: Yup.string().required(
            "Role Tier is required when you checked IsEcom"
          ),
        }
      : {}),
    ...(isSubCustomer
      ? {
          ParentCustId: Yup.string().required(
            "Parent Customer Is Requred When You Check Sub-Customer"
          ),
        }
      : {}),
    // TaxGroup: Yup.string().required("Tax Group is required"),
  });

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const title = [
    { label: "Mr.", value: "Mr." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Dr.", value: "Dr." },
    { label: "Hon.", value: "Hon." },
    { label: "Prof.", value: "Prof." },
    { label: "Rev.", value: "Rev." },
    { label: "Rt.Hon.", value: "Rt.Hon." },
    { label: "Sr.", value: "Sr." },
    { label: "Jr.", value: "Jr." },
    { label: "St.", value: "St." },
  ];

  const terms = [
    { label: "SalesTax", value: 1 },
    { label: "ItemTax", value: 2 },
    { label: "DataTax", value: 3 },
  ];

  // const terms1 = [{ label: "None", value: 0 }]

  const route = [
    { label: "OUT OF STATE", value: "OUT OF STATE" },
    { label: "MANHATTAN", value: "MANHATTAN" },
    { label: "BROOKLYN", value: "BROOKLYN" },
    { label: "BRONX", value: "BRONX" },
    { label: "QUEENS", value: "QUEENS" },
    { label: "STATEN ISLAND", value: "STATEN ISLAND" },
    { label: "LONG ISLAND", value: "LONG ISLAND" },
    { label: "UPSTATE", value: "UPSTATE" },
    { label: "NEW JERSEY", value: "NEW JERSEY" },
    { label: "PICK UP", value: 10 },
  ];

  const levelOption = [
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "C", value: "C" },
    { label: "D", value: "D" },
  ];
  const repOption = [
    { label: "HO", value: "HO" },
    { label: "FS", value: "FS" },
    { label: "DRV", value: "DRV" },
    { label: "YD", value: "YD" },
    { label: "AY", value: "AY" },
    { label: "QNS", value: "QNS" },
  ];

  const handleSelectOverrideDefaultTaxForSale = () => {
    setSelectOverrideDefaultTaxForSale(!selectOverrideDefaultTaxForSale);
  };

  const handleSelectTaxable = () => {
    setSelectTaxable(!selectTaxable);
  };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };

  const handleShowMore = () => {
    setShowMore(!showMore);
    setDisableCumulative(true);
  };

  const _handleFileChange = (e, index) => {
    setChangeImagename(true);
    // e.target.name == "File1" ? setImageUrl1(true) : setImageUrl1(false);
    if (e.target.name == "File1") {
      setImageUrl1(true);
    } else if (e.target.name == "File2") {
      setImageUrl2(true);
    } else if (e.target.name == "File3") {
      setImageUrl3(true);
    } else if (e.target.name == "File4") {
      setImageUrl4(true);
    } else if (e.target.name == "File5") {
      setImageUrl5(true);
    }
    // setImageUrl2(true);
    // setImageUrl3(true);
    // setImageUrl4(true);
    // setImageUrl5(true);
    setLoading(true);

    // console.log(
    //   e?.currentTarget?.files[0],
    //   e.target.name,
    //   index,
    //   "e?.currentTarget?.files[0], e.target.name, index"
    // );
    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name, index);
    }

    // if (e?.currentTarget?.name === "SelectImage") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // } else if (e?.currentTarget?.name === "File1") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage2(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // } else if (e?.currentTarget?.name === "File2") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage3(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // } else if (e?.currentTarget?.name === "File3") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage4(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // } else if (e?.currentTarget?.name === "File4") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage5(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // } else if (e?.currentTarget?.name === "File5") {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       setPreviewImage6(event.target.result);
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // }

    // if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
    //   console.log(1);
    //   uploadFile(e?.currentTarget?.files[0], e.target.name, index);
    // }
    setLoading(false);
  };
  const vaidation = (name, value) => {
    console.log(value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4|pdf)$/)) {
          setLoading(false);
          setChangeImagename(false);
          if (name == "File1") {
            setImageUrl1(true);
          } else if (name == "File2") {
            setImageUrl2(true);
          } else if (name == "File3") {
            setImageUrl3(true);
          } else if (name == "File4") {
            setImageUrl4(true);
          } else if (name == "File5") {
            setImageUrl5(true);
          }
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  //console.log(ImageUrl, "images");
  const uploadFile = async (file, type, event) => {
    console.log(type, "type===>");
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
      if (data) {
        if (type === "SelectImage") {
          setImageUrl(data);
          setChangeImagename(false);
          setLoading(false);
          //  handleSubmit(data, event);
        } else if (type === "File1") {
          setFile1Url(data);
          setImageUrl1(false);
          setLoading(false);
        } else if (type === "File2") {
          setFile2Url(data);
          setImageUrl2(false);
          setLoading(false);
        } else if (type === "File3") {
          setFile3Url(data);
          setImageUrl3(false);
          setLoading(false);
        } else if (type === "File4") {
          console.log(data, "File4===>");
          setFile4Url(data);
          setImageUrl4(false);
          setLoading(false);
        } else if (type === "File5") {
          console.log(data, "File5===>");
          setFile5Url(data);
          setImageUrl5(false);
          setLoading(false);
        } else {
          customFieldCustomerValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
          console.log("customFileUrl", customFileUrl);
          setChangeImagename(false);
          setImageUrl1(false);
          setImageUrl2(true);
          setImageUrl3(true);
          setImageUrl4(true);
          setImageUrl5(true);
          setLoading(false);
        }
      } else {
        setLoading(false);
        setChangeImagename(false);
        setImageUrl1(false);
        setImageUrl2(true);
        setImageUrl3(true);
        setImageUrl4(true);
        setImageUrl5(true);
      }
    });
  };
  // const uploadFile = async (file, type, event) => {
  //   console.log(file, "type===>");
  //   setBtnLoader({ [type]: true });
  //   setLoading(true);

  //   let urlsObject = {};

  //   await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
  //     if (data) {
  //       setLoading(false);

  //       switch (type) {
  //         case "SelectImage":
  //           setImageUrl(data);
  //           urlsObject = { ...urlsObject, imageUrl: data };
  //           break;
  //         case "File1":
  //           setFile1Url(data);
  //           urlsObject = { ...urlsObject, file1Url: data };
  //           break;
  //         case "File2":
  //           setFile2Url(data);
  //           urlsObject = { ...urlsObject, file2Url: data };
  //           break;
  //         case "File3":
  //           setFile3Url(data);
  //           urlsObject = { ...urlsObject, file3Url: data };
  //           break;
  //         case "File4":
  //           console.log(data, "File4===>");
  //           setFile4Url(data);
  //           urlsObject = { ...urlsObject, file4Url: data };
  //           break;
  //         case "File5":
  //           console.log(data, "File5===>");
  //           setFile5Url(data);
  //           urlsObject = { ...urlsObject, file5Url: data };
  //           break;
  //         default:
  //           customFieldCustomerValues[type] = {
  //             CustomFieldLabelID: type,
  //             CustomFieldValue: data,
  //           };
  //           setCustomFileUrl(data);
  //           console.log("customFileUrl", customFileUrl);
  //           urlsObject = { ...urlsObject, customFileUrl: data };
  //           break;
  //       }

  //       handleSubmit(urlsObject, event);
  //     }
  //   });
  // };

  let TaxDropdownOption = [];
  const RoleDropdown = taxdropdown.map((u, i) => {
    TaxDropdownOption[i] = { label: u.Name, value: u.ID };
  });

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/taxclassdropdown`)
      .then((res) => setTaxDropDown(res.data.ResponseData))
      .catch((error) => console.log(error));
  }, []);

  let RoleTierDropdownOption = [];
  const RolesTierDropdown = roletierdropdown.map((u, i) => {
    RoleTierDropdownOption[i] = { label: u.Name, value: u.ID };
  });

  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => setRoleTierDropDown(res.data.ResponseData))
      .catch((error) => console.log(error));

    axios
      .get(`${config.customersBaseUrl}/customers/parentcustomerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => setisParentCustomer(res.data.ResponseData))
      .catch((error) => console.log(error));
  }, []);

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    console.log("fieldName:", fieldTypeName);
    if (fieldTypeName === "Dropdown") {
      customFieldCustomerValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.value,
      };
    } else if (fieldTypeName === "Checkbox") {
      console.log(event.target.checked);
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked,
      };
    } else if (fieldName === "E-Mail") {
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Website") {
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "PhoneNumber") {
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Date") {
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else {
      customFieldCustomerValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    }
  };

  // useEffect(() => {
  //   if (paramObject.id === undefined) {
  //     setCustomer(false)
  //   }
  // }, [])

  const handleRoleTierChange = (e) => {
    setSelectedRoleTier(e.value);
  };

  // const handleSubmit2 = async (eventdata) => {
  //   setLoading(true);
  //   var arrayvalue = [
  //     {
  //       filedata:filedata,
  //       filename:filename,
  //     }
  //   ]
  //   console.log(arrayvalue[0].filedata,"arrayvalue");
  //   for (let i = 0; i < arrayvalue[0].filedata.length; i++) {
  //     if (arrayvalue[0].filedata[i]) {

  //       if (vaidation("Imagename", arrayvalue[0].filedata[i])) {
  //      var result = await uploadFile(
  //           arrayvalue[0].filedata[i],
  //           arrayvalue[0].filename[i],
  //           eventdata
  //         );

  //       }
  //        console.log(result , "resultdata");
  //     } else {
  //       console.log(eventdata, "event");
  //       handleSubmit("", eventdata);
  //     }
  //   }
  // };

  const handleSubmit = (values) => {
    // console.log(1)
    // console.log("values handleSubmit: ", values);

    //console.log("AutoEmailReceipt ==>", imageurl);

    // return false;
    console.log(values, "datavalue");

    let taxValues = [
      {
        TaxId: values.TaxId1,
        TaxName: values.TaxName1,
        TaxPercent: values.TaxPercent1,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId2,
        TaxName: values.TaxName2,
        TaxPercent: values.TaxPercent2,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId3,
        TaxName: values.TaxName3,
        TaxPercent: values.TaxPercent3,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId4,
        TaxName: values.TaxName4,
        TaxPercent: values.TaxPercent4,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId5,
        TaxName: values.TaxName5,
        TaxPercent: values.TaxPercent5,
        TaxCumulative: values.Cumulative,
      },
    ];

    let fileValues = [
      {
        FilesId: values.FileId1,
        FileName: File1Url,
      },
      {
        FilesId: values.FileId2,
        FileName: File2Url,
      },
      {
        FilesId: values.FileId3,
        FileName: File3Url,
      },
      {
        FilesId: values.FileId4,
        FileName: File4Url,
      },
      {
        FilesId: values.FileId5,
        FileName: File5Url,
      },
    ];

    let taxdata = taxValues.filter(function (rowData) {
      return rowData.TaxName !== "";
    });

    let filedata = fileValues.filter(function (rowData) {
      return rowData.FileName !== "";
    });

    let customFielddata = customFieldCustomerValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });
    // console.log("customFielddata: ", customFielddata);

    let taxValuesData = {};
    let fileValuesData = {};
    let customValuesData = {};

    // taxValuesData.customerTaxXML = taxdata;
    taxValuesData.customerTaxXML = [];
    fileValuesData.customerFilesXML = filedata;
    customValuesData.customValueXML = customFielddata;

    let taxjsonstring = JSON.stringify(taxValuesData);
    let filejsonstring = JSON.stringify(fileValuesData);
    let customvaluejsonstring = JSON.stringify(customValuesData);

    console.log("customvaluejsonstring: ", customvaluejsonstring);
    console.log(selectedTerms, "selectedTermsinsert");
    console.log(terms1, "terms1");

    let customerData = {
      xmlcustomertax: taxjsonstring,
      xmlcustomerfiles: filejsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      id: paramObject.id ? paramObject.id : 0,
      companyname: values.CompanyName,
      firstname:
        selectedTitle === null
          ? values.FirstName
          : selectedTitle.value + " " + values.FirstName,
      lastname: values.LastName,
      email: values.EMail,
      phonenumber: phoneNumber.replace(/[-()\s]/g, ''), //values.PhoneNumber
      image: ImageUrl,
      address1: values.Address1,
      address2: values.Address2,
      city: values.City,
      stateprovince: values.StateProvince,
      zip: values.Zip,
      country: values.Country,
      comments: values.Comments,
      internalnotes: values.InternalNotes,
      storeAccountbalance: values.StoreAccountBalance,
      creditlimit: values.CreditLimit,
      terms: selectedTerms?.value || selectedTerms,
      QuickBookIDterms: selectedTerms?.QuickBookID,
      accountnumber: values.Account,
      overridedefaulttaxforsale: values.OverrideDefaultTaxForSale,
      taxgroup: selectedTaxGroup,
      roletierid: values.RoleTierID, // selectedRoleTier,
      taxable: values.Taxable,
      nontaxcertificatenumber: values.NonTaxCertificateNumber,
      messagetoshowwhenaddingcustomertosales:
        values.MessageToShowWhenAddingCustomerToSale,
      autoemailreceipt: values.AutoEmailReceipt,
      rep: selectedRep,
      level: selectedLevel,
      alternatephone: values.AlternatePhone,
      taxid: values.TaxID,
      electroniccigaretteid: values.ElectronicCigaretteId,
      instagram: values.Instagram,
      tobaccolicense: values.TobaccoLicense,
      route: selectedRoute,
      openingbalance:
        values.OpeningBalance === ""
          ? 0
          : values.OpeningBalance === undefined
          ? 0
          : values.OpeningBalance,
      loginuserid: Id,
      quickbookid: quickbookid,
      titleneed: selectedTitle === null ? "" : selectedTitle.value,
      firstnameneed: values.FirstName,
      isecom: isecom === true ? 1 : 0,
      quantity: quantity === true ? 1 : 0,
      UserName: values.Username,
      Password: values.Password,
      isSubCustomer: isSubCustomer === true ? 1 : 0,
      isParentCustomer: selectParentCustomer ? selectParentCustomer : 0,
      subcustomer: subcustomer,
      billparentcustomer: billparentcustomer ? 1 : 0,
      isLocation: Location,
      AllowResell: AllowResell == true ? 1 : 0 ,
    };
    // console.log("route==>", selectedRoute);
    // console.log("taxgroup==>", selectedTaxGroup.label);
    console.log("customerData: ", customerData.terms);

    // return
    console.log(isSubCustomer, "isSubCustomer44444");
    console.log(isParentCustomer, "isS1236ubCustomer44444");

    if (isSubCustomer) {
      if (selectParentCustomer < 1) {
        toastError("Parent Customer Is Required When You Check Sub-Customer");
        return;
      }
    }

    setLoading(true);
    axios
      .post(`${config.customersBaseUrl}/customers/upsert`, customerData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/customers");
          navigate(-1);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Email" + ALREADY_EXIST);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -4
        ) {
          toastError(Message_DATA3);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -5
        ) {
          toastError(Message_DATA);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -3
        ) {
          toastError("Account Number" + ALREADY_EXIST);
        }

        setLoading(false);

        // backtopreviouspage();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  let terms1 = [];
  const TermsDropdown = termsDropdown.map((u, i) => {
    terms1[i] = {
      label: u.Name,
      value: u.ID,
      days: u.Value,
      QuickBookID: u.QuickBookID,
    };
  });

  console.log(terms1, "terms list");
  console.log(selectedTerms, "selectedTerms");
  //  let variable = terms1.find(
  //   (option) =>
  //     option?.QuickBookID ==
  //     selectedTerms.QuickBookID)
  //settermQuickBookID(variable.QuickBookID)
  useEffect(() => {
    // Binding Customer Fields

    if (ComponentURl) {
      setStatement(true);
    } else {
      if (paramObject.id == undefined) {
        setCustomer(true);
      }
    }

    axios
      .get(
        `${config.customersBaseUrl}/customers/customercustomgetall?id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData.customefield);
      })
      .catch((err) => {
        console.log("Error: ", err);
        setLoading(false);
      });

    if (paramObject.id > 0) {
      setLoading(true);

      if (ComponentURl) {
        setStatement(true);
      } else {
        setListingData(true);
      }

      axios
        .get(
          `${config.customersBaseUrl}/customers/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res?.data?.ResponseData?.CustomerDetails[0].AllowResell, "resresresAllowResell")
          const customerdata = res.data.ResponseData.CustomerDetails[0];
          setQuickbookid(customerdata.QuickbookID);
          setquantity(customerdata.DisplayQuantityEComm === 1 ? true : false);
          setisecom(customerdata.IsEcommerceUser === 1 ? true : false);
          setIsSubCustomer(customerdata?.IsSubCustomer == 1 ? true : false);
          setbillparentcustomer(customerdata?.BillToParent == 1 ? true : false);
          setpassworddeable(customerdata.ParentCustomerId);
          setpassworddeable(customerdata.IsEcommerceUser);
          const taxData = res.data.ResponseData.TaxDetails;
          const fileData = res.data.ResponseData.FileDetails;
          const customFieldValueData = res.data.ResponseData.CustomFieldValues;
          setFileDetails(res.data.ResponseData.FileDetails);
          setCustomerDetails(customerdata);
          setAllowResell(customerdata?.AllowResell == 1 ? true : false)

          const customerdatas = res.data.ResponseData.parentID[0];
          setsubcustomer(customerdatas?.QuickbookID);
          let firstname = customerdata.FirstName;
          let firstnames = customerdata.FirstName.split(" ");
          console.log(firstnames, "firstnamedata");

          var title = [
            { label: "Mr.", value: "Mr." },
            { label: "Mrs.", value: "Mrs." },
            { label: "Dr.", value: "Dr." },
            { label: "Hon.", value: "Hon." },
            { label: "Prof.", value: "Prof." },
            { label: "Rev.", value: "Rev." },
            { label: "Rt.Hon.", value: "Rt.Hon." },
            { label: "Sr.", value: "Sr." },
            { label: "Jr.", value: "Jr." },
            { label: "St.", value: "St." },
          ];

          let dataFromIndex1ToLast = firstnames.slice(1);
          let dataFromIndex1ToLasts = firstnames.slice(0);

          let dataAsString = dataFromIndex1ToLast.join(" ");
          let dataAsStrings = dataFromIndex1ToLasts.join(" ");

          function titlefind(text) {
            for (var i = 0; i < title.length; i++) {
              if (title[i].value.toLowerCase() === text.toLowerCase()) {
                return 1;
              }
            }
            return 0;
          }

          let dataarray = titlefind(firstnames[0]);

          setSelectOverrideDefaultTaxForSale(
            customerdata.OverrideDefaultTaxForSale === 1 ? true : false
          );

          title.map((selectTitle) => {
            if (selectTitle.value === firstnames[0]) {
              setSelectedTitle(selectTitle);
              // console.log(selectedTitle);
            }
          });

          console.log(customerdata, "get terms");
          setSelectedTerms(customerdata?.Terms);

          // terms.map((selectterm) => {
          //   console.log("selectterm", selectterm);
          //   if (selectterm.label === customerdata.Terms) {
          //     // console.log("terrrns",selectedTerms);
          //   }
          // });

          setSelectedTaxGroup(customerdata.TaxGroup);
          setSelectedRoleTier(customerdata.RoleTierID);
          // taxdropdown.map((selecttax) => {
          //   if (selecttax.value === customerdata.TaxGroup) {
          //     setSelectedTaxGroup(selecttax);
          //     // console.log("taxxigroup",selectedTaxGroup);
          //   }
          // });

          setSelectedRoute(customerdata.Route);
          setSelectedLevel(customerdata.LEVEL);
          setSelectedRep(customerdata.REP);
          // route.map((selectroute) => {
          //   // console.log("selectroute",selectroute);
          //   if (selectroute.label === customerdata.Route) {
          //     setSelectedRoute(selectroute);
          //     console.log("selectedRoute==>", selectedRoute);
          //   }
          // });

          setSelectTaxable(customerdata.Taxable === 1 ? true : false);
          setImageUrl(customerdata.Image);
          setDisableCumulative(taxData[1]?.Cumulative === 1 ? true : false);

          if (taxData.length > 2) {
            setShowMore(true);
          }

          // setisParentCustomer(customerdata.ParentCustomerId)
          setSelectParentCustomer(customerdata.ParentCustomerId);
          let input = customerdata.PhoneNumber

          // Loop through each character of input
          for (let i = 0; i < input.length; i++) {
            const char = input[i];
            // Remove any character from input which is not 0-9, -, (, ), or 'space'
            if (!/[-()0-9\s]/.test(char)) {
              input = removeLastCharacter(input, i);
              i--; // Adjust loop after character removal
            } else {
              symbolPosition(char, i, input);
            }
          }
      
          // Format number if it has 10 digits and no unwanted characters
          if (/^\d{10}$/.test(input.replace(/[-()\s]/g, ''))) {
            input = formatNumber(input);
          }
      
          setPhoneNumber(input);

          const data = {
            CompanyName: customerdata.CompanyName,
            Title: dataarray === 1 ? firstnames[0] : "",
            FirstName: dataarray === 1 ? dataAsString : dataAsStrings,
            LastName: customerdata.LastName,
            EMail: customerdata.Email,
            PhoneNumber: customerdata.PhoneNumber,
            SelectImage: "",
            Address1: customerdata.Address1,
            Address2: customerdata.Address2,
            City: customerdata.City,
            StateProvince: customerdata.StateProvince,
            Zip: customerdata.Zip,
            Country: customerdata.Country,
            Comments: customerdata.Comments,
            InternalNotes: customerdata.InternalNotes,
            StoreAccountBalance: parseFloat(customerdata.Balance).toFixed(2),
            CreditLimit: customerdata.CreditLimit,
            Terms: customerdata.Terms,
            Account: customerdata.AccountNumber,
            OverrideDefaultTaxForSale:
              customerdata.OverrideDefaultTaxForSale === 1 ? true : false,
            TaxGroup: customerdata.TaxGroup,
            TaxId1: taxData[0]?.Id,
            TaxName1: taxData[0]?.Name,
            TaxPercent1: taxData[0]?.Percent,
            TaxId2: taxData[1]?.Id,
            TaxName2: taxData[1]?.Name,
            TaxPercent2: taxData[1]?.Percent,
            Cumulative: taxData[1]?.Cumulative,
            TaxId3: taxData[3]?.Id,
            TaxName3: taxData[3]?.Name,
            TaxPercent3: taxData[3]?.Percent,
            TaxId4: taxData[4]?.Id,
            TaxName4: taxData[4]?.Name,
            TaxPercent4: taxData[4]?.Percent,
            TaxId5: taxData[5]?.Id,
            TaxName5: taxData[5]?.Name,
            TaxPercent5: taxData[5]?.Percent,
            Taxable: customerdata.Taxable === 1 ? true : false,
            NonTaxCertificateNumber: customerdata.NonTaxCertificateNumber,
            MessageToShowWhenAddingCustomerToSale:
              customerdata.MessageToShowWhenAddingCustomerToSales,
            AutoEmailReceipt:
              customerdata.AutoEmailReceipt === 0 ? false : true,
            REP: customerdata.REP,
            AlternatePhone: customerdata.AlternatePhone,
            TaxID: customerdata.taxId,
            ElectronicCigaretteId: customerdata.ElectronicCigaretteId,
            Instagram: customerdata.Instagram,
            TobaccoLicense: customerdata.TobaccoLicense,
            ROUTE: customerdata.Route,
            OpeningBalance: customerdata.Openingbalance,
            AccountBalance: customerdata.Balance,
            FileId1: fileData[0]?.Id,
            File1: "",
            FileId2: fileData[1]?.Id,
            File2: "",
            FileId3: fileData[2]?.Id,
            File3: "",
            FileId4: fileData[3]?.Id,
            File4: "",
            FileId5: fileData[4]?.Id,
            File5: "",
            RoleTierID: customerdata.RoleTierID,
            Username: customerdata.Username,
            isSubCustomer: customerdata?.IsSubCustomer == 1 ? true : false,
            billparentcustomer: customerdata?.BillToParent == 1 ? true : false,
            ParentCustId: customerdata.ParentCustomerId,
            // Password: customerdata.Password,
          };

          console.log(customerdata, "customerdata");

          const newData = { ...data };
          for (let i = 0; i < customFieldValueData.length; i++) {
            newData[customFieldValueData[i].CustomFieldControlID] =
              customFieldValueData[i].Value === "false"
                ? false
                : customFieldValueData[i].Value === "true"
                ? true
                : customFieldValueData[i].Value;
          }
          console.log(newData, "avsdfd");

          setFormValues(newData);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }

    // Accounting Terms Drop Down Axios Call
    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res.data.ResponseData, "terms list");
        setTermsDropdown(res.data.ResponseData);
        console.log(res.data.ResponseData, "res.data.ResponseData");
      })
      .catch((err) => {
        console.log(err);
      });
  }, [paramObject.id]);

  // console.log(paramObject.id)
  console.log("customer:", customer);

  const backtopreviouspage = () => {
    navigate(-1);
  };

  const handleSubCustomerChange = (e) => {
    const isChecked = e.target.checked;
    setIsSubCustomer(isChecked);
    if (!isChecked) {
      setbillparentcustomer(false); // or '' or undefined, depending on your use case
      setisParentCustomer("");
    }
  };

  const handleChangeEcom = (e) => {
    setAllowResell(e.target.checked)
    console.log(e.target.checked , 'Check Event')
    }
  




  const handleInputChange = (e) => {
    let input = e.target.value;

    // Loop through each character of input
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
      // Remove any character from input which is not 0-9, -, (, ), or 'space'
      if (!/[-()0-9\s]/.test(char)) {
        input = removeLastCharacter(input, i);
        i--; // Adjust loop after character removal
      } else {
        symbolPosition(char, i, input);
      }
    }

    // Format number if it has 10 digits and no unwanted characters
    if (/^\d{10}$/.test(input.replace(/[-()\s]/g, ''))) {
      input = formatNumber(input);
    }

    setPhoneNumber(input);
  };

  console.log(phoneNumber,"phoneNumbersss")

  const removeLastCharacter = (input, index) => {
    return input.substring(0, index) + input.substring(index + 1);
  };

  const symbolPosition = (char, index, input) => {
    switch (char) {
      case '(':
        if (index !== 0) {
          input = removeLastCharacter(input, index);
        }
        break;
      case ')':
        if (index !== 4) {
          input = removeLastCharacter(input, index);
        }
        break;
      case '-':
        if (index !== 9) {
          input = removeLastCharacter(input, index);
        }
        break;
      case ' ':
        if (index !== 5) {
          input = removeLastCharacter(input, index);
        }
        break;
      default:
        break;
    }
    return input;
  };

  const formatNumber = (phone) => {
    let formattedPhone = phone.replace(/[-()\s]/g, ''); // Remove existing symbols
    return `(${formattedPhone.substring(0, 3)}) ${formattedPhone.substring(3, 6)}-${formattedPhone.substring(6)}`;
  };

  return (
    <>
      {!ComponentURl && <Sidebar />}
      <Loader loading={loading} />
      <div className={ComponentURl ? "" : "page-wrapper cardhead"}>
        <div className="content container-fluid">
          {/* <div className="row mb-4">
            <div className="col">
              <h3 className="page-title">Customer</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/customers">Customers List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Customer</li>
              </ul>
            </div>
          </div> */}
          {!ComponentURl && (
            <div
              className="page-header"
              style={{
                position: "fixed",
                top: "2px",
                zIndex: "999",
              }}
            >
              <div className="row breadcrumb-position">
                {/* <h3 className="page-title">Customer</h3> */}
                <ul className="breadcrumb">
                  <li
                    className="breadcrumb-item"
                    style={{ marginLeft: "12px" }}
                  >
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/customers">Customers List</Link>
                  </li>
                  <li className="breadcrumb-item active">Manage Customer</li>
                </ul>
              </div>
            </div>
          )}
          {/* <div className="page-wrapper"> */}
          <>
            {/* {paramObject.id > 0 && (
              <div
                style={{
                  padding: "10px",
                  display: "flex",
                  columnGap: "21px",
                  marginBottom: "15px",
                }}
              >
                <div
                  style={{
                    // border: "1px solid rgba(107, 108, 114, 0.61)",
                    // padding: "20px",
                    // borderRadius: "4px",
                    // boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                    // width: "78%",
                    // backgroundColor: "white",
                  }}
                >
                  <h2>{customerdetails.CompanyName}</h2>
                  <p
                    style={{
                      marginBottom: "0",
                      fontSize: "large",
                      paddingLeft: "12px",
                    }}
                  >
                    {customerdetails?.Address1 +
                      " " +
                      customerdetails?.Address2}
                  </p>
                  <p
                    style={{
                      marginBottom: "0",
                      fontSize: "large",
                      paddingLeft: "12px",
                    }}
                  >
                    {customerdetails?.City +
                      ", " +
                      customerdetails?.StateProvince +
                      ", " +
                      customerdetails?.Country}
                  </p>
                  <p
                    style={{
                      marginBottom: "0",
                      fontSize: "large",
                      paddingLeft: "12px",
                    }}
                  >
                    {customerdetails?.Zip}
                  </p>
                </div>
                <div
                  style={{
                    border: "1px solid rgba(107, 108, 114, 0.61)",
                    padding: "20px",
                    borderRadius: "4px",
                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                    width: "20%",
                    backgroundColor: "white",
                  }}
                >
                  <h5 style={{ fontweight: "600" }}>SUMMARY</h5>
                  <div>
                    <h3
                      style={{
                        paddingLeft: "10px",
                        borderLeft: "5px solid blue",
                      }}
                    >
                      ${parseFloat(customerdetails?.OpenBalance).toFixed(2)}
                    </h3>
                    <p
                      style={{
                        marginBottom: "10px",
                        color: "rgb(0, 0, 0)",
                        // fontSize: "initial",
                        lineHeight: "20px",
                        marginLeft: "15px",
                      }}
                    >
                      Open Balance
                    </p>
                  </div>
                  <div>
                    <h5
                      style={{
                        paddingLeft: "10px",
                        borderLeft: "5px solid rgb(255, 202, 0)",
                      }}
                    >
                      ${parseFloat(customerdetails?.Balance).toFixed(2)}
                    </h5>
                    <p
                      style={{
                        marginBottom: "10px",
                        color: "rgb(0, 0, 0)",
                        // fontSize: "initial",
                        lineHeight: "20px",
                        marginLeft: "15px",
                      }}
                    >
                      Customer Wallet Balance
                    </p>
                  </div>
                  <div>
                    <h5
                      style={{
                        paddingLeft: "10px",
                        borderLeft: "5px solid rgb(228, 56, 52)",
                      }}
                    >
                      {customerdetails?.OverduePayment == null
                        ? `$${parseFloat(0).toFixed(2)}`
                        : `$${parseFloat(
                            customerdetails?.OverduePayment
                          ).toFixed(2)}`}
                    </h5>
                    <p
                      style={{
                        color: "rgb(0, 0, 0)",
                        // fontSize: "initial",
                        lineHeight: "20px",
                        marginLeft: "15px",
                      }}
                    >
                      Overdue payment
                    </p>
                  </div>
                </div>
              </div>
            )} */}

            {paramObject.id > 0 && !ComponentURl && (
              <div
                style={{
                  // border: "1px solid black",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  borderRadius: "15px",
                  backgroundColor: "#ffffff",
                  // columnGap: "21px",
                  // marginBottom: "15px",
                }}
              >
                <div
                  style={{
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",

                    // border: "1px solid rgba(107, 108, 114, 0.61)",
                    // borderRadius: "4px",
                    // boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                    // width: "78%",
                    // backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      // border:'1px solid black',
                      display: "flex",
                      width: "50px",
                      height: "50px",
                      margin: "10px",
                    }}
                  >
                    <img
                      src={customerdetails?.Image}
                      alt={customerdetails?.FirstName}
                      onError={(e) => {
                        e.target.src = Noimage;
                      }}
                      // width="50px"
                      // height="50px"
                      style={{
                        borderRadius: "50%",
                        // border:'1px solid black'
                      }}
                    />
                  </div>
                  <div>
                    {/* <h2>{supplierdetails?.CompanyName}</h2> */}
                    {/* <p className="p-lg">{customerdetails?.CompanyName}</p> */}
                    <p className="p-lg">
                      {customerdetails?.FirstName +
                        " " +
                        customerdetails?.LastName}
                    </p>
                    <p
                      style={{ fontWeight: "800" }}
                      className="mt-2 fs-5 font-weight-bold"
                    >
                      Company Name :{" "}
                      {customerdetails?.CustType == 0 ? (
                        <i class="fa fa-briefcase"></i>
                      ) : customerdetails?.CustType == 1 ? (
                        <i class="fa fa-group"></i>
                      ) : customerdetails?.CustType == 2 ? (
                        <i class="fa fa-user-circle"></i>
                      ) : (
                        ""
                      )} {""}
                      {customerdetails?.ParentCustomerName
                        ? customerdetails?.ParentCustomerName + " | "
                        : ""}{" "}
                      {customerdetails?.CompanyName}
                      
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      {customerdetails?.Address1 || ""}{" "}
                      {customerdetails?.Address2
                        ? `${customerdetails.Address2}`
                        : ""}
                      {customerdetails?.City ? `,${customerdetails.City}` : ""}
                      {customerdetails?.StateProvince
                        ? `,${customerdetails.StateProvince}`
                        : ""}
                      {customerdetails?.Country
                        ? `,${customerdetails.Country}`
                        : ""}{" "}
                      {customerdetails?.Zip ? `${customerdetails.Zip}` : ""}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    // padding: "20px",
                    display: "flex",
                    // borderRadius: "4px",
                    // boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                    // width: "20%",
                    // backgroundColor: "white",
                  }}
                >
                  <div style={{ padding: "5px 15px", margin: "14px" }}>
                    <p className="p">
                      ${parseFloat(customerdetails?.OpenBalance).toFixed(2)}
                    </p>
                    <p className="p-medium">
                      {/* Open balance */}
                      Open Balance
                    </p>
                  </div>
                  <div
                    style={{
                      borderLeft: "1px solid black",
                      padding: "5px 15px",
                      margin: "14px",
                    }}
                  >
                    <p className="p">
                      $
                      {parseFloat(
                        customerdetails?.BalanceCredit == null
                          ? 0
                          : customerdetails?.BalanceCredit
                      ).toFixed(2)}
                    </p>
                    <p className="p-medium">Credit Balance</p>
                  </div>
                  <div
                    style={{
                      borderLeft: "1px solid black",
                      padding: "5px 15px",
                      margin: "14px",
                    }}
                  >
                    <p className="p">
                      {customerdetails?.OverduePayment == null
                        ? `$${parseFloat(0).toFixed(2)}`
                        : `$${parseFloat(
                            customerdetails?.OverduePayment
                          ).toFixed(2)}`}
                    </p>
                    <p className="p-medium">Overdue payment</p>
                  </div>
                </div>
              </div>
            )}
            <div>
              {/* <div className="col-lg-2 col-md-12"> */}
              {/* <h5  className="card-title">Customer Information</h5> */}

              {/* <ul class="inbox-menu nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li  class="nav-item" role="presentation" onClick={() => { setCustomer(true); setListingData(false) }}>
                  <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Customer Information</button>
                  </li>
                  <li  class="nav-item" role="presentation" onClick={() => handledata(1)}>
                  <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Invoice</button>
                  </li>
                  <li class="nav-item" role="presentation" onClick={() => handledata(5)}>
                  <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Received Payments</button>
                  </li>
                  <li class="nav-item" role="presentation"  onClick={() => handledata(2)}>
                  <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Return / Memo</button>
                  </li>
                  <li class="nav-item" role="presentation"  onClick={() => handledata(3)}>
                  <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Estimates</button>
                  </li>
                  <li class="nav-item" role="presentation"  onClick={() => handledata(4)}>
                  <button class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Customer Account</button>
                  </li>
                </ul> */}

              {paramObject.id > 0 && !ComponentURl ? (
                <div
                  className="nav nav-pills"
                  style={{ gap: "10px", margin: "10px 0px" }}
                >
                  <li className="nav-item" onClick={() => handledata(0)}>
                    <a
                      // class="nav-link active"
                      className="btn btn-sm new-btn-customer nav-link1 "
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i class="fa fa-credit-card mr-2" aria-hidden="true"></i>
                      Transaction
                    </a>
                  </li>

                  <li
                    class="nav-item"
                    onClick={() => {
                      setStatement(false);
                      setCustomer(true);
                      setPayment(false);
                      setListingData(false);
                      setComment(false);
                      setInternalNotes(false);
                    }}
                  >
                    <a
                      // class="nav-link active"
                      className="btn btn-sm new-btn-customer nav-link1"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i class="fa fa-user-o mr-2" aria-hidden="true"></i>
                      Customer Information
                    </a>
                  </li>

                  <li class="nav-item" onClick={handleStatement}>
                    <a
                      // class="nav-link active"
                      className="btn btn-sm new-btn-customer nav-link1"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i
                        class="fa fa-building-o menu-icon mr-2"
                        aria-hidden="true"
                      ></i>
                      Statement
                    </a>
                  </li>
                  {/* <li class="nav-item" onClick={() => handledata(1)}>
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="pill"
                        role="tab"
                      >
                        <i class="fa fa-file-text" aria-hidden="true"></i>
                        <span id="cust">Invoice</span>
                      </a>
                    </li> */}

                  {/* <li className="nav-item" onClick={() => handledata(2)}>
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="pill"
                        role="tab"
                      >
                        <i class="fa fa-credit-card" aria-hidden="true"></i>
                        <span id="cust">Return / Credit Memo</span>
                      </a>
                    </li> */}
                  {/* <li className="nav-item" onClick={() => handledata(3)}>
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="pill"
                        role="tab"
                      >
                        <i class="fa fa-balance-scale" aria-hidden="true"></i>
                        <span id="cust">Estimates</span>
                      </a>
                    </li> */}
                  {/* <li className="nav-item" onClick={() => handledata(4)}>
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="pill"
                        role="tab"
                      >
                        <i class="fa fa-folder-open" aria-hidden="true"></i>
                        <span id="cust">Customer Account</span>
                      </a>
                    </li> */}

                  {/* Receive Payment  */}

                  {/* <li class="nav-item" onClick={handlePayment}>
                      <a
                        class="nav-link"
                        href="javascript:void(0);"
                        data-bs-toggle="pill"
                        role="tab"
                      >
                        <i class="fa fa-money" aria-hidden="true"></i>
                        <span id="cust">Received Payments</span>
                      </a>
                    </li> */}

                  <li class="nav-item" onClick={handleComment}>
                    <a
                      // class="nav-link active"
                      className="btn btn-sm new-btn-customer nav-link1"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i class="fa fa-comment-o mr-2" aria-hidden="true"></i>
                      Comments
                    </a>
                  </li>
                  <li class="nav-item" onClick={handleNotes}>
                    <a
                      // class="nav-link active"
                      className="btn btn-sm new-btn-customer nav-link1"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i
                        class="fa fa-sticky-note-o mr-2"
                        aria-hidden="true"
                      ></i>
                      Internal Notes
                    </a>
                  </li>
                </div>
              ) : (
                ""
              )}
              {/* </div> */}

              {customer === true ? (
                <div
                // className={
                //   paramObject.id > 0
                //     ? "col-lg-10 col-md-12"
                //     : "col-lg-12 col-md-12"
                // }
                >
                  <div className="card bg-white">
                    <div className="">
                      <div className="email-header">
                        <div className="row">
                          <div className="col-lg-20 top-action-left col-sm-20">
                            <div>
                              {/* <ul
                                class="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              > */}
                              {/* <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link active"
                                    id="personal-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#home"
                                    type="button"
                                    role="tab"
                                    aria-controls="home"
                                    aria-selected="true"
                                    onClick={() => handleCustomer(1)}
                                  >
                                    Personal Details
                                  </button>
                                </li> */}
                              {/* <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="address-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(2)}
                                  >
                                    Address
                                  </button>
                                </li> */}
                              {/* <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="account-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(3)}
                                  >
                                    Account/Balance
                                  </button>
                                </li> */}
                              {/* <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="tax-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(4)}
                                  >
                                    Tax
                                  </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="custom-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(5)}
                                  >
                                    Custom Fields
                                  </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="files-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(6)}
                                  >
                                    Files
                                  </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                  <button
                                    class="nav-link"
                                    id="otherdetails-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    onClick={() => handleCustomer(7)}
                                  >
                                    Other Details
                                  </button>
                                </li> */}
                              {/* </ul> */}
                              <Formik
                                {...props}
                                initialValues={formValues}
                                validationSchema={validationSchema}
                                enableReinitialize
                                onSubmit={handleSubmit}
                              >
                                {({
                                  errors,
                                  touched,
                                  handleChange,
                                  validateForm,
                                }) => (
                                  <>
                                    <Form>
                                      <div className="card-header">
                                        <h5 className="card-title">
                                          Customer Information
                                        </h5>
                                      </div>
                                      <hr style={{ color: "#e9ecef" }} />
                                      <div className="card-body">
                                        {/* {managecustomerID === 1 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Personal Details
                                          </p>
                                          <div className="col-md-12">
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Company Name
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.CompanyName
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="CompanyName"
                                                      name="CompanyName"
                                                    />

                                                    <div className="invalid-feedback">
                                                      {touched.CompanyName &&
                                                      errors.CompanyName
                                                        ? errors.CompanyName
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    First Name{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-lg-8">
                                                    <div className="row">
                                                      <div className="col-md-5">
                                                        <Select
                                                          isClearable={true}
                                                          onChange={
                                                            setSelectedTitle
                                                          }
                                                          options={title}
                                                          placeholder=""
                                                          styles={
                                                            CUSTOM_SELECT_DROPDOWN_STYLE
                                                          }
                                                          value={selectedTitle}
                                                          id="Title"
                                                          name="Title"
                                                          className="custom-search-select "
                                                          // style={{
                                                          //   width: "200px",
                                                          // }}
                                                        />
                                                      </div>
                                                      <div
                                                        // style={{width: "80px"}}
                                                        className="col-md-7"
                                                      >
                                                        <Field
                                                          type="text"
                                                          className={`form-control form-control-sm ${
                                                            errors.FirstName
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="FirstName"
                                                          name="FirstName"
                                                        />
                                                        <div className="invalid-feedback">
                                                          {touched.FirstName &&
                                                          errors.FirstName
                                                            ? errors.FirstName
                                                            : ""}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Last Name
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.LastName
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="LastName"
                                                      name="LastName"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.LastName &&
                                                      errors.LastName
                                                        ? errors.LastName
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    E-Mail{" "}
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="Email123456"
                                                      className={`form-control form-control-sm ${
                                                        errors.EMail
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="EMail"
                                                      name="EMail"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.EMail &&
                                                      errors.EMail
                                                        ? errors.EMail
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Phone Number{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  {/* <div className="col-md-8">
                                                    <Field
                                                      type="tel"
                                                      className={`form-control form-control-sm ${
                                                        errors.PhoneNumber
                                                          ? "is-invalid custom-invalid-border"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="PhoneNumber"
                                                      name="PhoneNumber"
                                                      
                                                      maxLength="10"
                                                      minLength="10"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.PhoneNumber &&
                                                      errors.PhoneNumber
                                                        ? errors.PhoneNumber
                                                        : ""}
                                                    </div>
                                                  </div> */}
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.PhoneNumber
                                                          ? "is-invalid custom-invalid-border"
                                                          : ""
                                                      }`}
                                                      onChange={handleInputChange}
                                                      id="PhoneNumber"
                                                      name="PhoneNumber"
                                                      value={phoneNumber}
                                                      maxLength="14"
                                                      minLength="14"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.PhoneNumber &&
                                                      errors.PhoneNumber
                                                        ? errors.PhoneNumber
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Role Tier
                                                    {isecom ? (
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      as="select"
                                                      name="RoleTierID"
                                                      id="RoleTierID"
                                                      onChange={handleChange}
                                                      className="form-control form-control-sm"
                                                    >
                                                      <option value="">
                                                        Select Role
                                                      </option>
                                                      {RoleTierDropdownOption.map(
                                                        (item) => {
                                                          return (
                                                            <option
                                                              value={item.value}
                                                            >
                                                              {item.label}
                                                            </option>
                                                          );
                                                        }
                                                      )}
                                                    </Field>
                                                    {isecom ? (
                                                      <div className="invalid-feedback">
                                                        {touched.RoleTierID &&
                                                        errors.RoleTierID
                                                          ? errors.RoleTierID
                                                          : ""}
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Select Image
                                                  </label>
                                                  <div className="col-md-8">
                                                    <FileInput
                                                      id="SelectImage"
                                                      name="SelectImage"
                                                      className="form-control form-control-sm"
                                                      value={selectedImage}
                                                      accept="image/*"
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                    {changeImagename && (
                                                      <i class="fa fa-refresh fa-spin"></i>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            {/* <div className="col-sm-6"></div> */}
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                {!changeImagename && (
                                                  <div
                                                    className={`row ${
                                                      !ImageUrl &&
                                                      !selectedImage
                                                        ? "d-none"
                                                        : ""
                                                    }`}
                                                  >
                                                    <label className="col-form-label col-md-4 form-label"></label>
                                                    <div className="col-md-8">
                                                      <img
                                                        src={
                                                          ImageUrl ||
                                                          selectedImage ||
                                                          ""
                                                        }
                                                        alt="Category Image"
                                                        className="ImagePreviewSize"
                                                      />
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>

                                            <div>
                                            <div className="row">
                                                <label className="col-form-label col-md-2 form-label fw-bold">
                                                  Allow Resell
                                                </label>
                                                <div
                                                style={{
                                                  width: "30px",
                                                  marginTop: "4px",
                                                  marginRight: "16px",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  id="AllowResell"
                                                  name="AllowResell"
                                                  // value="true"
                                                  checked={AllowResell}
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeEcom(e);
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            </div>

                                            <div className="row d-flex">
                                              <label className="col-form-label col-md-2 form-label fw-bold">
                                                Is a Sub customer
                                              </label>
                                              <div
                                                style={{
                                                  width: "30px",
                                                  marginTop: "4px",
                                                  marginRight: "16px",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  id="IsSubCust"
                                                  name="IsSubCust"
                                                  value="true"
                                                  checked={isSubCustomer}
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                  onChange={(e) => {
                                                    handleSubCustomerChange(e);
                                                  }}
                                                />
                                              </div>
                                              {isSubCustomer && (
                                                <div className="col-md-9">
                                                  <div className="row">
                                                    <div
                                                      style={{ width: "136px" }}
                                                    >
                                                      <label className="col-form-label form-label">
                                                        Parent Customer
                                                        <span className="text-danger">
                                                          *
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <div
                                                      style={{
                                                        marginright: "14px",
                                                      }}
                                                      className="col-md-4"
                                                    >
                                                      {isParentCustomer > 0 ? (
                                                        <Select
                                                          options={
                                                            isParentCustomer
                                                          }
                                                          placeholder="Select a Parent Customer"
                                                          backspaceRemovesValue={
                                                            false
                                                          }
                                                          controlShouldRenderValue={
                                                            true
                                                          }
                                                          hideSelectedOptions={
                                                            true
                                                          }
                                                          isClearable={false}
                                                          styles={
                                                            CUSTOM_SELECT_DROPDOWN_STYLE
                                                          }
                                                          id="ParentCustId"
                                                          name="ParentCustId"
                                                          onChange={(event) => {
                                                            console.log(
                                                              event,
                                                              "8888"
                                                            );
                                                            setSelectParentCustomer(
                                                              event?.value
                                                            );
                                                            setsubcustomer(
                                                              event?.QuickbookID
                                                            );
                                                          }}
                                                          value={isParentCustomer.find(
                                                            (option) => {
                                                              return (
                                                                option.value ===
                                                                selectParentCustomer
                                                              );
                                                            }
                                                          )}
                                                          className="custom-search-select"
                                                        />
                                                      ) : (
                                                        <Select
                                                          style={{
                                                            border:
                                                              "1px solid red",
                                                          }}
                                                          options={
                                                            isParentCustomer
                                                          }
                                                          placeholder="Select a Parent Customer"
                                                          backspaceRemovesValue={
                                                            false
                                                          }
                                                          controlShouldRenderValue={
                                                            true
                                                          }
                                                          hideSelectedOptions={
                                                            true
                                                          }
                                                          isClearable={false}
                                                          styles={
                                                            CUSTOM_SELECT_DROPDOWN_STYLE
                                                          }
                                                          id="ParentCustId"
                                                          name="ParentCustId"
                                                          onChange={(event) => {
                                                            console.log(
                                                              event,
                                                              "8888"
                                                            );
                                                            setSelectParentCustomer(
                                                              event?.value
                                                            );
                                                            setsubcustomer(
                                                              event?.QuickbookID
                                                            );
                                                          }}
                                                          value={isParentCustomer?.find(
                                                            (option) => {
                                                              return (
                                                                option.value ==
                                                                selectParentCustomer
                                                              );
                                                            }
                                                          )}
                                                          className="custom-search-select"
                                                        />
                                                      )}
                                                      {isSubCustomer ? (
                                                        <div className="invalid-feedback">
                                                          {touched.ParentCustId &&
                                                          errors.ParentCustId
                                                            ? errors.ParentCustId
                                                            : ""}
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                    <div className="col-md-2">
                                                      <label className="col-form-label form-label">
                                                        Bill Parent Customer
                                                      </label>
                                                    </div>
                                                    <div
                                                      style={{
                                                        marginTop: "6px",
                                                      }}
                                                      className="col-md-1"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        id="billparentcust"
                                                        name="billparentcust"
                                                        value="true"
                                                        checked={
                                                          billparentcustomer
                                                        }
                                                        style={{
                                                          height: "20px",
                                                          width: "20px",
                                                        }}
                                                        onChange={(e) =>
                                                          setbillparentcustomer(
                                                            e?.target?.checked
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>

                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-4 form-label fw-bold">
                                                  Allow Ecom Access
                                                </label>

                                                <div className="col-md-8">
                                                  <div className="row">
                                                    <div className="col react-select-height">
                                                      <input
                                                        type="checkbox"
                                                        id="myCheckbox"
                                                        name="myCheckbox"
                                                        value="true"
                                                        checked={isecom}
                                                        onChange={() =>
                                                          setisecom(!isecom)
                                                        }
                                                        style={{
                                                          height: "20px",
                                                          width: "20px",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* ) : (
                                          ""
                                        )} */}
                                        {isecom ? (
                                          <div className="row col-md-12">
                                            <p className="p-medium mb-20">
                                              Ecom customer Login
                                            </p>
                                            <div className="col-md-12">
                                              <div className="row mb-2">
                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-4 form-label">
                                                      Username{" "}
                                                      {/* <span className="text-danger">
                *
              </span> */}
                                                    </label>
                                                    <div className="col-md-8">
                                                      <Field
                                                        as="input"
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        onChange={handleChange}
                                                        id="Username"
                                                        name="Username"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    {paramObject.id > 0 &&
                                                    passworddeable === 1 ? (
                                                      <div
                                                        className="btn btn-primary"
                                                        onClick={() =>
                                                          setPasswordModalOpen(
                                                            true
                                                          )
                                                        }
                                                        style={{
                                                          width: "183px",
                                                        }}
                                                      >
                                                        {" "}
                                                        Change Password
                                                      </div>
                                                    ) : (
                                                      <>
                                                        <label className="col-form-label col-md-4 form-label">
                                                          Password
                                                        </label>
                                                        <div className="col-md-8">
                                                          <Field
                                                            as="input"
                                                            type="password"
                                                            placeholder={
                                                              paramObject.id >
                                                                0 &&
                                                              passworddeable ===
                                                                1
                                                                ? "..."
                                                                : "Password"
                                                            }
                                                            className="form-control form-control-sm"
                                                            onChange={
                                                              handleChange
                                                            }
                                                            id="Password"
                                                            name="Password"
                                                            disabled={
                                                              paramObject.id >
                                                                0 &&
                                                              passworddeable ===
                                                                1
                                                            }
                                                          />
                                                        </div>
                                                      </>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label ">
                                                    Display Quantity
                                                  </label>

                                                  <div className="col-md-8">
                                                    <div className="row">
                                                      <div className="col react-select-height">
                                                        <input
                                                          type="checkbox"
                                                          id="myCheckbox"
                                                          name="myCheckbox"
                                                          value="true"
                                                          checked={quantity}
                                                          onChange={() =>
                                                            setquantity(
                                                              !quantity
                                                            )
                                                          }
                                                          style={{
                                                            height: "20px",
                                                            width: "20px",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        {isecom ? (
                                          <hr style={{ color: "#e9ecef" }} />
                                        ) : null}
                                        {/* {managecustomerID === 2 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Address
                                          </p>
                                          <div className="col-md-12">
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Address 1{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      as="textarea"
                                                      className={`form-control form-control-sm ${
                                                        errors.Address1
                                                          ? "is-invalid custom-invalid-border"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="Address1"
                                                      name="Address1"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.Address1 &&
                                                      errors.Address1
                                                        ? errors.Address1
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Address 2{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      as="textarea"
                                                      className={`form-control form-control-sm ${
                                                        errors.Address2
                                                          ? "is-invalid custom-invalid-border"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="Address2"
                                                      name="Address2"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.Address2 &&
                                                      errors.Address2
                                                        ? errors.Address2
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    City{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8 mt-1">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.City
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="City"
                                                      name="City"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.City &&
                                                      errors.City
                                                        ? errors.City
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    State/Province{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8 mt-1">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.StateProvince
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="StateProvince"
                                                      name="StateProvince"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.StateProvince &&
                                                      errors.StateProvince
                                                        ? errors.StateProvince
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Zip Code
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8 mt-1">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.Zip
                                                          ? "is-invalid custom-invalid-border"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="Zip"
                                                      name="Zip"
                                                      maxLength="6"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.Zip && errors.Zip
                                                        ? errors.Zip
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Country{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8 mt-1">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.Country
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="Country"
                                                      name="Country"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.Country &&
                                                      errors.Country
                                                        ? errors.Country
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />

                                        {/* ) : (
                                          ""
                                        )} */}

                                        {/* {managecustomerID === 3 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Account/Balance
                                          </p>
                                          <div className="col-md-12">
                                            <div className="row">
                                              {/* <div className="col-sm-6">
                                                <div className=" row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Store Account Balance
                                                  </label>

                                                  <div className="col-md-8">
                                                    <Field
                                                      type="number"
                                                      className={`form-control form-control-sm ${errors.StoreAccountBalance
                                                        ? "is-invalid"
                                                        : ""
                                                        }`}
                                                      onChange={handleChange}
                                                      id="StoreAccountBalance"
                                                      name="StoreAccountBalance"
                                                      disabled={
                                                        paramObject.id > 0
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.StoreAccountBalance &&
                                                        errors.StoreAccountBalance
                                                        ? errors.StoreAccountBalance
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div> */}
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Credit Limit
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="number"
                                                      className={`form-control form-control-sm ${
                                                        errors.CreditLimit
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="CreditLimit"
                                                      name="CreditLimit"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.CreditLimit &&
                                                      errors.CreditLimit
                                                        ? errors.CreditLimit
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Terms
                                                  </label>
                                                  <div className="col-md-8">
                                                    {/* <Field as='select' className="form-control select" id="Terms" name="Terms" onChange={handleChange}>
                                                            <option>None</option>
                                                        </Field> */}
                                                    <Select
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      onChange={
                                                        setSelectedTerms
                                                      }
                                                      options={terms1}
                                                      placeholder="Select Terms"
                                                      styles={
                                                        CUSTOM_SELECT_DROPDOWN_STYLE
                                                      }
                                                      // value={selectedTerms}
                                                      value={terms1.find(
                                                        (option) =>
                                                          option?.value ==
                                                          selectedTerms //selectedTerm
                                                      )}
                                                      id="Terms"
                                                      name="Terms"
                                                      className="custom-search-select"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mt-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Bank Account No
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>

                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${
                                                        errors.Account
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="Account"
                                                      name="Account"
                                                      maxLength="50"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.Account &&
                                                      errors.Account
                                                        ? errors.Account
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Opening Balance{" "}
                                                    {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="number"
                                                      className={`form-control form-control-sm ${
                                                        errors.OpeningBalance
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="OpeningBalance"
                                                      name="OpeningBalance"
                                                      disabled={
                                                        paramObject.id > 0
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.OpeningBalance &&
                                                      errors.OpeningBalance
                                                        ? errors.OpeningBalance
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* ) : (
                                          ""
                                        )} */}

                                        {/* {managecustomerID === 4 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">TAX</p>
                                          <div className="col-md-12 mb-3">
                                            <div className="row mb-2">
                                              <div className="col-sm-12">
                                                <div className=" row">
                                                  <div className="col-md-8">
                                                    <Field
                                                      className="form-check-input"
                                                      style={{
                                                        width: "1.5em",
                                                        height: "1.5em",
                                                        marginTop: "10px",
                                                      }}
                                                      type="checkbox"
                                                      id="OverrideDefaultTaxForSale"
                                                      name="OverrideDefaultTaxForSale"
                                                      onChange={handleChange}
                                                      onInput={
                                                        handleSelectOverrideDefaultTaxForSale
                                                      }
                                                    />
                                                    <label className="col-form-label col-md-6 form-label ml-2 mt-1">
                                                      Override Default Tax For
                                                      Sale
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className={`${
                                                selectOverrideDefaultTaxForSale ===
                                                true
                                                  ? ""
                                                  : "d-none"
                                              }`}
                                            >
                                              <div className="row mb-2">
                                                <div className="col-sm-12">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Tax Group 12
                                                      {/* <span className="text-danger">
                                                      *
                                                    </span> */}
                                                    </label>
                                                    <div className="col-md-10">
                                                      {/* <Field as='select' className="form-control select" id="TaxGroup" name="TaxGroup" onChange={handleChange}>
                                                                <option>None</option>
                                                            </Field> */}
                                                      <Select
                                                        backspaceRemovesValue={
                                                          false
                                                        }
                                                        controlShouldRenderValue={
                                                          true
                                                        }
                                                        hideSelectedOptions={
                                                          true
                                                        }
                                                        isClearable={true}
                                                        onChange={(e) =>
                                                          handleLocationChange(
                                                            e
                                                          )
                                                        }
                                                        options={
                                                          TaxDropdownOption
                                                        }
                                                        placeholder=""
                                                        styles={
                                                          CUSTOM_SELECT_DROPDOWN_STYLE
                                                        }
                                                        value={TaxDropdownOption.find(
                                                          (option) =>
                                                            option?.value ==
                                                            selectedTaxGroup
                                                        )}
                                                        id="TaxGroup"
                                                        name="TaxGroup"
                                                        className="custom-search-select"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row mb-2">
                                                <div className="col-sm-12">
                                                  <div className="">
                                                    <h4 className="text-center p-20 bold">
                                                      OR
                                                    </h4>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row mb-2">
                                                <div className="col-sm-12">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Tax 1
                                                    </label>
                                                    <div className="col-md-5">
                                                      <Field
                                                        type="hidden"
                                                        name="TaxId1"
                                                      />
                                                      <Field
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        onChange={handleChange}
                                                        id="TaxName1"
                                                        name="TaxName1"
                                                        placeholder="Tax Name"
                                                      />
                                                    </div>
                                                    <div className="col-md-5">
                                                      <Field
                                                        type="text"
                                                        className={`form-control form-control-sm ${
                                                          errors.TaxPercent1
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="TaxPercent1"
                                                        name="TaxPercent1"
                                                        placeholder="Tax Percent"
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.TaxPercent1 &&
                                                        errors.TaxPercent1
                                                          ? errors.TaxPercent1
                                                          : ""}
                                                      </div>
                                                    </div>
                                                    {/* <div className="col-md-1">
                                                            <span>%</span>
                                                        </div> */}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row mb-2">
                                                <div className="col-sm-12">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Tax 2
                                                    </label>
                                                    <div className="col-md-5">
                                                      <Field
                                                        type="hidden"
                                                        name="TaxId2"
                                                      />
                                                      <Field
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        onChange={handleChange}
                                                        id="TaxName2"
                                                        name="TaxName2"
                                                        placeholder="Tax Name"
                                                      />
                                                    </div>
                                                    <div className="col-md-3">
                                                      <Field
                                                        type="text"
                                                        className={`form-control form-control-sm ${
                                                          errors.TaxPercent2
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="TaxPercent2"
                                                        name="TaxPercent2"
                                                        placeholder="Tax Percent"
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.TaxPercent2 &&
                                                        errors.TaxPercent2
                                                          ? errors.TaxPercent2
                                                          : ""}
                                                      </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                      {/* <span>%</span> */}
                                                      <Field
                                                        className="form-check-input"
                                                        style={{
                                                          width: "1.5em",
                                                          height: "1.5em",
                                                        }}
                                                        type="checkbox"
                                                        id="Cumulative"
                                                        name="Cumulative"
                                                        onChange={handleChange}
                                                        disabled={
                                                          disableCumulative
                                                        }
                                                      />
                                                      <span> Cumulative</span>
                                                    </div>
                                                    <div
                                                      className={`col-form-label col-md-2 form-label mt-3 ${
                                                        showMore === false
                                                          ? ""
                                                          : "d-none"
                                                      }`}
                                                    >
                                                      <Link
                                                        onClick={handleShowMore}
                                                      >
                                                        Show More
                                                      </Link>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className={`${
                                                  showMore === true
                                                    ? ""
                                                    : "d-none"
                                                }`}
                                              >
                                                <div className="row mb-2">
                                                  <div className="col-sm-12">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-2 form-label">
                                                        Tax 3:
                                                      </label>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="hidden"
                                                          name="TaxId3"
                                                        />
                                                        <Field
                                                          type="text"
                                                          className="form-control form-control-sm"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxName3"
                                                          name="TaxName3"
                                                          placeholder="Tax Name"
                                                        />
                                                      </div>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="text"
                                                          className={`form-control form-control-sm ${
                                                            errors.TaxName3
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxPercent3"
                                                          name="TaxPercent3"
                                                          placeholder="Tax Percent"
                                                        />
                                                        <div className="invalid-feedback">
                                                          {touched.TaxName3 &&
                                                          errors.TaxName3
                                                            ? errors.TaxName3
                                                            : ""}
                                                        </div>
                                                        {/* <span>%</span> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row mb-2">
                                                  <div className="col-sm-12">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-2 form-label">
                                                        Tax 4
                                                      </label>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="hidden"
                                                          name="TaxId4"
                                                        />
                                                        <Field
                                                          type="text"
                                                          className="form-control form-control-sm"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxName4"
                                                          name="TaxName4"
                                                          placeholder="Tax Name"
                                                        />
                                                      </div>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="text"
                                                          className={`form-control form-control-sm ${
                                                            errors.TaxName4
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxPercent4"
                                                          name="TaxPercent4"
                                                          placeholder="Tax Percent"
                                                        />
                                                        <div className="invalid-feedback">
                                                          {touched.TaxName4 &&
                                                          errors.TaxName4
                                                            ? errors.TaxName4
                                                            : ""}
                                                        </div>
                                                        {/* <span>%</span> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row mb-2">
                                                  <div className="col-sm-12">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-2 form-label">
                                                        Tax 5
                                                      </label>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="hidden"
                                                          name="TaxId5"
                                                        />
                                                        <Field
                                                          type="text"
                                                          className="form-control form-control-sm"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxName5"
                                                          name="TaxName5"
                                                          placeholder="Tax Name"
                                                        />
                                                      </div>
                                                      <div className="col-md-5">
                                                        <Field
                                                          type="text"
                                                          className={`form-control form-control-sm ${
                                                            errors.TaxName5
                                                              ? "is-invalid"
                                                              : ""
                                                          }`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="TaxPercent5"
                                                          name="TaxPercent5"
                                                          placeholder="Tax Percent"
                                                        />
                                                        <div className="invalid-feedback">
                                                          {touched.TaxName5 &&
                                                          errors.TaxName5
                                                            ? errors.TaxName5
                                                            : ""}
                                                        </div>
                                                        {/* <span>%</span> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className=" row">
                                                  <div className="col-md-8">
                                                    <Field
                                                      className="form-check-input mt-2"
                                                      style={{
                                                        width: "1.5em",
                                                        height: "1.5em",
                                                      }}
                                                      type="checkbox"
                                                      id="Taxable"
                                                      name="Taxable"
                                                      onChange={handleChange}
                                                      onInput={
                                                        handleSelectTaxable
                                                      }
                                                    />
                                                    <label className="col-form-label col-md-4 form-label ml-2">
                                                      Taxable
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className={`col-sm-6 ${
                                                  selectTaxable === false
                                                    ? ""
                                                    : "d-none"
                                                }`}
                                              >
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Non Tax Certificate Number
                                                  </label>
                                                  <div className="col-md-8 mt-2">
                                                    <Field
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="NonTaxCertificateNumber"
                                                      name="NonTaxCertificateNumber"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Tax ID
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="TaxID"
                                                      name="TaxID"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Electronic Cigarette Id
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="ElectronicCigaretteId"
                                                      name="ElectronicCigaretteId"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="row">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Tobacco License
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="TobaccoLicense"
                                                      name="TobaccoLicense"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* ) : (
                                          ""
                                        )} */}

                                        {/* {managecustomerID === 6 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Files
                                          </p>
                                          <div className="row col-md-12">
                                            <div className="">
                                              {/* <div className="card-header">
                                                <h5 className="card-title">
                                                  Files
                                                </h5>
                                              </div> */}
                                              <div className="card-body">
                                                <div className="row mb-2">
                                                  <div className="col-sm-6">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        File 1
                                                      </label>

                                                      <div className="col-md-8">
                                                        <Field
                                                          type="hidden"
                                                          name="FileId1"
                                                        />
                                                        <FileInput
                                                          id="File1"
                                                          name="File1"
                                                          className="form-control form-control-sm"
                                                          accept="image/*"
                                                          // value={filedetails[0]?.FileName}
                                                          handleChange={
                                                            _handleFileChange
                                                          }
                                                        />
                                                        {ImageUrl1 && (
                                                          <i class="fa fa-refresh fa-spin"></i>
                                                        )}
                                                        <a
                                                          href={
                                                            File1Url
                                                              ? File1Url
                                                              : filedetails[0]
                                                                  ?.FileName
                                                          }
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {(File1Url ||
                                                            filedetails[0]
                                                              ?.FileName) &&
                                                            "Attachment"}
                                                        </a>
                                                      </div>
                                                      {/* <div>
                                                  <a href={File1Url}></a>
                                                </div> */}
                                                    </div>
                                                  </div>
                                                  <div className="col-sm-6">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        File 2
                                                      </label>
                                                      <div className="col-md-8">
                                                        <Field
                                                          type="hidden"
                                                          name="FileId2"
                                                          className="form-control form-control-sm"
                                                        />
                                                        <FileInput
                                                          id="File2"
                                                          name="File2"
                                                          className="form-control form-control-sm"
                                                          value={
                                                            filedetails[1]
                                                              ?.FileName
                                                          }
                                                          handleChange={
                                                            _handleFileChange
                                                          }
                                                        />
                                                        {ImageUrl2 && (
                                                          <i class="fa fa-refresh fa-spin"></i>
                                                        )}
                                                        <a
                                                          href={
                                                            File2Url
                                                              ? File2Url
                                                              : filedetails[1]
                                                                  ?.FileName
                                                          }
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {(File2Url ||
                                                            filedetails[1]
                                                              ?.FileName) &&
                                                            "Attachment"}
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row mb-2">
                                                  <div className="col-sm-6">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        File 3
                                                      </label>
                                                      <div className="col-md-8">
                                                        <Field
                                                          type="hidden"
                                                          name="FileId3"
                                                          className="form-control form-control-sm"
                                                        />
                                                        <FileInput
                                                          id="File3"
                                                          name="File3"
                                                          className="form-control form-control-sm"
                                                          value={
                                                            filedetails[2]
                                                              ?.FileName
                                                          }
                                                          handleChange={
                                                            _handleFileChange
                                                          }
                                                        />
                                                        {ImageUrl3 && (
                                                          <i class="fa fa-refresh fa-spin"></i>
                                                        )}
                                                        <a
                                                          href={
                                                            File3Url ? (
                                                              <a
                                                                href={File3Url}
                                                              >
                                                                Attachment
                                                              </a>
                                                            ) : (
                                                              filedetails[2]
                                                                ?.FileName
                                                            )
                                                          }
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {(File3Url ||
                                                            filedetails[2]
                                                              ?.FileName) &&
                                                            "Attachment"}
                                                        </a>

                                                        {/* <Field
                                                                    type="file"
                                                                    name="File3"
                                                                    id="File3"
                                                                    className={`form-control`}
                                                                    value={selectedFile3}
                                                                    onChange={_handleFileChange}
                                                                /> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-sm-6">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        File 4
                                                      </label>
                                                      <div className="col-md-8">
                                                        <Field
                                                          type="hidden"
                                                          name="FileId4"
                                                          className="form-control form-control-sm"
                                                        />
                                                        <FileInput
                                                          id="File4"
                                                          name="File4"
                                                          className="form-control form-control-sm"
                                                          value={
                                                            filedetails[3]
                                                              ?.FileName
                                                          }
                                                          handleChange={
                                                            _handleFileChange
                                                          }
                                                        />
                                                        {ImageUrl4 && (
                                                          <i class="fa fa-refresh fa-spin"></i>
                                                        )}
                                                        <a
                                                          href={
                                                            File4Url
                                                              ? File4Url
                                                              : filedetails[3]
                                                                  ?.FileName
                                                          }
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {(File4Url ||
                                                            filedetails[3]
                                                              ?.FileName) &&
                                                            "Attachment"}
                                                        </a>

                                                        {/* <Field
                                                                    type="file"
                                                                    name="File4"
                                                                    id="File4"
                                                                    className={`form-control`}
                                                                    value={selectedFile4}
                                                                    onChange={_handleFileChange}
                                                                /> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="row">
                                                  <div className="col-sm-6">
                                                    <div className="row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        File 5
                                                      </label>
                                                      <div className="col-md-8">
                                                        <Field
                                                          type="hidden"
                                                          name="FileId5"
                                                          className="form-control form-control-sm"
                                                        />
                                                        <FileInput
                                                          id="File5"
                                                          name="File5"
                                                          className="form-control form-control-sm"
                                                          value={
                                                            filedetails[4]
                                                              ?.FileName
                                                          }
                                                          handleChange={
                                                            _handleFileChange
                                                          }
                                                        />
                                                        {ImageUrl5 && (
                                                          <i class="fa fa-refresh fa-spin"></i>
                                                        )}
                                                        <a
                                                          href={
                                                            File5Url
                                                              ? File5Url
                                                              : filedetails[4]
                                                                  ?.FileName
                                                          }
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                        >
                                                          {(File5Url ||
                                                            filedetails[4]
                                                              ?.FileName) &&
                                                            "Attachment"}
                                                        </a>

                                                        {/* <Field
                                                                    type="file"
                                                                    name="File5"
                                                                    id="File5"
                                                                    className={`form-control`}
                                                                    value={selectedFile5}
                                                                    onChange={_handleFileChange}
                                                                /> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* ) : (
                                           ""
                                         )}  */}
                                        {/* {managecustomerID === 7 ? ( */}
                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Other Details
                                          </p>
                                          <div className="col-md-12">
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Message To Show When Adding
                                                    Customer To Sale
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      as="textarea"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="MessageToShowWhenAddingCustomerToSale"
                                                      name="MessageToShowWhenAddingCustomerToSale"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <div className="col-md-8">
                                                    <Field
                                                      className="form-check-input"
                                                      style={{
                                                        width: "1.5em",
                                                        height: "1.5em",
                                                        marginTop: "10px",
                                                      }}
                                                      type="checkbox"
                                                      id="AutoEmailReceipt"
                                                      name="AutoEmailReceipt"
                                                      onChange={handleChange}
                                                    />
                                                    <label
                                                      className="col-form-label col-md-6 form-label ml-2"
                                                      style={{
                                                        marginTop: "3px",
                                                      }}
                                                    >
                                                      Auto Email Receipt
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                            <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Instagram
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      onChange={handleChange}
                                                      id="Instagram"
                                                      name="Instagram"
                                                    />
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    Alternate Phone
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Field
                                                      type="number"
                                                      className={`form-control form-control-sm ${
                                                        errors.AlternatePhone
                                                          ? "is-invalid"
                                                          : ""
                                                      }`}
                                                      onChange={handleChange}
                                                      id="AlternatePhone"
                                                      name="AlternatePhone"
                                                      maxLength="10"
                                                    />
                                                    <div className="invalid-feedback">
                                                      {touched.AlternatePhone &&
                                                      errors.AlternatePhone
                                                        ? errors.AlternatePhone
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="row">
                                            <div className="col-sm-6">
                                              <div className=" row">
                                                <label className="col-form-label col-md-4 form-label">
                                                  Tax ID
                                                </label>
                                                <div className="col-md-8">
                                                  <Field
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    id="TaxID"
                                                    name="TaxID"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-6">
                                              <div className=" row">
                                                <label className="col-form-label col-md-4 form-label">
                                                  Electronic Cigarette Id
                                                </label>
                                                <div className="col-md-8">
                                                  <Field
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    id="ElectronicCigaretteId"
                                                    name="ElectronicCigaretteId"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div> */}
                                            <div className="row mb-2"> 
                                             
                                              {/* <div className="col-sm-6">
                                                    <div className=" row">
                                                      <label className="col-form-label col-md-4 form-label">
                                                        Tobacco License
                                                      </label>
                                                      <div className="col-md-8">
                                                        <Field
                                                          type="text"
                                                          className="form-control"
                                                          onChange={handleChange}
                                                          id="TobaccoLicense"
                                                          name="TobaccoLicense"
                                                        />
                                                      </div>
                                                    </div>
                                                </div> */}
                                              {/* </div>
                                                <div className="row"> */}
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    ROUTE
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Select
                                                      options={route}
                                                      onChange={(e) =>
                                                        setSelectedRoute(
                                                          e?.value
                                                            ? e?.value
                                                            : ""
                                                        )
                                                      }
                                                      value={route.find(
                                                        (el) =>
                                                          el.value ===
                                                          selectedRoute
                                                      )}
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      placeholder="Select Route"
                                                      styles={
                                                        CUSTOM_SELECT_DROPDOWN_STYLE
                                                      }
                                                      id="Route"
                                                      name="Route"
                                                      className="custom-search-select"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    REP
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Select
                                                      options={repOption}
                                                      onChange={(e) =>
                                                        setSelectedRep(
                                                          e?.value
                                                            ? e?.value
                                                            : ""
                                                        )
                                                      }
                                                      value={repOption.find(
                                                        (el) =>
                                                          el.value ===
                                                        selectedRep
                                                      )}
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      placeholder="Select REP"
                                                      styles={
                                                        CUSTOM_SELECT_DROPDOWN_STYLE
                                                      }
                                                      id="REP"
                                                      name="REP"
                                                      className="custom-search-select"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-4 form-label">
                                                    LEVEL
                                                  </label>
                                                  <div className="col-md-8">
                                                    <Select
                                                      options={levelOption}
                                                      onChange={(e) =>
                                                        setSelectedLevel(
                                                          e?.value
                                                            ? e?.value
                                                            : ""
                                                        )
                                                      }
                                                      value={levelOption.find(
                                                        (el) =>
                                                          el.value ===
                                                        selectedLevel
                                                      )}
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      placeholder="Select REP"
                                                      styles={
                                                        CUSTOM_SELECT_DROPDOWN_STYLE
                                                      }
                                                      id="REP"
                                                      name="REP"
                                                      className="custom-search-select"
                                                    />
                                                  </div>
                                                </div>
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* {managecustomerID === 5 ? ( */}

                                        <div className=" row col-md-12">
                                          <p className="p-medium mb-20">
                                            Custom Fields
                                          </p>
                                          <div>
                                            <div className="row">
                                              {customFields.map(
                                                (data, index) => (
                                                  <>
                                                    <label
                                                      className="col-form-label col-md-2 form-label"
                                                      key={index}
                                                    >
                                                      {data.Name}
                                                    </label>

                                                    <div className="col-md-4">
                                                      {data.TypeName ===
                                                      "Text" ? (
                                                        <Field
                                                          key={index}
                                                          type="text"
                                                          className="form-control"
                                                          onChange={(event) => {
                                                            handleChange(event);
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                        />
                                                      ) : data.TypeName ===
                                                        "Email" ? (
                                                        <Field
                                                          key={index}
                                                          type="email"
                                                          className="form-control"
                                                          onChange={(event) => {
                                                            handleChange(event);
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                        />
                                                      ) : data.TypeName ===
                                                        "Dropdown" ? (
                                                        <>
                                                          <Select
                                                            key={index}
                                                            id={data.TypeName}
                                                            name={data.Id}
                                                            backspaceRemovesValue={
                                                              false
                                                            }
                                                            controlShouldRenderValue={
                                                              true
                                                            }
                                                            hideSelectedOptions={
                                                              true
                                                            }
                                                            isClearable={true}
                                                            onChange={(
                                                              event
                                                            ) => {
                                                              handleCustomFieldsValues(
                                                                event,
                                                                data.TypeName,
                                                                data.Id
                                                              );
                                                              setSelectedCustomField(
                                                                event,
                                                                index
                                                              );
                                                            }}
                                                            options={data.Optionvalue.split(
                                                              ","
                                                            ).map((option) => ({
                                                              label: option,
                                                              value: option,
                                                              selected:
                                                                option ===
                                                                formValues[
                                                                  data.Id
                                                                ],
                                                            }))}
                                                            placeholder="Select"
                                                            styles={
                                                              CUSTOM_SELECT_DROPDOWN_STYLE
                                                            }
                                                            defaultValue={
                                                              formValues[
                                                                data.Id
                                                              ] !== null &&
                                                              formValues[
                                                                data.Id
                                                              ] !== ""
                                                                ? {
                                                                    label:
                                                                      formValues[
                                                                        data.Id
                                                                      ],
                                                                    value:
                                                                      formValues[
                                                                        data.Id
                                                                      ],
                                                                  }
                                                                : ""
                                                            }
                                                          />
                                                        </>
                                                      ) : data.TypeName ===
                                                        "Checkbox" ? (
                                                        <Field
                                                          key={index}
                                                          className="form-check-input form-control"
                                                          style={{
                                                            width: "1.5em",
                                                            height: "1.5em",
                                                          }}
                                                          type="checkbox"
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                          onChange={(event) => {
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                            handleChange(event);
                                                          }}
                                                          onInput={
                                                            handleSelectCustomCheckBox
                                                          }
                                                        />
                                                      ) : data.TypeName ===
                                                        "Website" ? (
                                                        <Field
                                                          key={index}
                                                          type="text"
                                                          className="form-control"
                                                          onChange={(event) => {
                                                            handleChange(event);
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                        />
                                                      ) : data.TypeName ===
                                                        "PhoneNumber" ? (
                                                        <Field
                                                          key={index}
                                                          type="tel"
                                                          className="form-control"
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                          onChange={(event) => {
                                                            handleChange(event);
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                        />
                                                      ) : data.TypeName ===
                                                        "Date" ? (
                                                        <Field
                                                          key={index}
                                                          className="form-control"
                                                          type="date"
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                          onChange={(event) => {
                                                            handleChange(event);
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                        />
                                                      ) : data.TypeName ===
                                                        "Image" ? (
                                                        <>
                                                          <div className="row">
                                                            <FileInput
                                                              key={index}
                                                              className="form-control"
                                                              id={data.TypeName}
                                                              name={data.Id}
                                                              value={
                                                                selectedCustomImage
                                                              }
                                                              accept="image/*"
                                                              handleChange={(
                                                                event
                                                              ) => {
                                                                _handleFileChange(
                                                                  event,
                                                                  index
                                                                );
                                                                handleCustomFieldsValues(
                                                                  event,
                                                                  data.TypeName,
                                                                  data.Name
                                                                );
                                                              }}
                                                            />
                                                          </div>

                                                          <div className="row">
                                                            <div className="mt-2">
                                                              <div
                                                                className={`${
                                                                  formValues[
                                                                    data.Id
                                                                  ]
                                                                    ? ""
                                                                    : selectedCustomImage
                                                                    ? ""
                                                                    : "d-none"
                                                                }  row`}
                                                              >
                                                                <label className="col-form-label col-md-2 form-label"></label>
                                                                <div>
                                                                  <img
                                                                    src={`${
                                                                      formValues[
                                                                        data.Id
                                                                      ]
                                                                        ? formValues[
                                                                            data
                                                                              .Id
                                                                          ]
                                                                        : selectedCustomImage
                                                                    }`}
                                                                    alt="Category Image"
                                                                    className="ImagePreviewSize"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </>
                                                      ) : data.TypeName ===
                                                        "File" ? (
                                                        <FileInput
                                                          key={index}
                                                          className="form-control"
                                                          id={data.TypeName}
                                                          name={data.Id}
                                                          value={
                                                            selectedCustomFile
                                                          }
                                                          handleChange={(
                                                            event
                                                          ) => {
                                                            _handleFileChange(
                                                              event,
                                                              index
                                                            );
                                                            handleCustomFieldsValues(
                                                              event,
                                                              data.TypeName,
                                                              data.Name
                                                            );
                                                          }}
                                                        />
                                                      ) : null}
                                                    </div>
                                                  </>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <hr style={{ color: "#e9ecef" }} />
                                        {/* ) : (
                                          ""
                                        )} */}
                                        {/* ) : (
                                          ""
                                        )} */}
                                        <div>
                                          <div className="pull-right ">
                                            <button
                                              type="submit"
                                              className="btn btn-sm btn-primary pull-right mb-3 mt-2"
                                              onClick={() => {
                                                validateForm().then(
                                                  (errors) => {
                                                    console.log(
                                                      "Errors:--",
                                                      errors
                                                    );

                                                    if (
                                                      Object.keys(errors)
                                                        .length === 0
                                                    ) {
                                                      console.log(
                                                        "Form is valid"
                                                      );

                                                      return true;
                                                    } else {
                                                      console.log(
                                                        "Form is invalid"
                                                      );

                                                      {
                                                        isecom
                                                          ? toastError(
                                                              "Role Tier is required when you checked Ecom "
                                                            )
                                                          : toastError(
                                                              "Please Fill Proper Values"
                                                            );
                                                      }

                                                      return false;
                                                    }
                                                  }
                                                );
                                              }}
                                            >
                                              Save
                                            </button>
                                            <div
                                              onClick={backtopreviouspage}
                                              // className="btn btn-secondary mb-3 "
                                              className="btn btn-sm btn-dark btn-md me-1 pull-right mt-2"
                                            >
                                              Cancel
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* </ConditionalComponent> */}
                                    </Form>
                                  </>
                                )}
                              </Formik>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {listingdata === true ? (
                <Customerlisting listid={listid} customerid={paramObject.id} />
              ) : (
                ""
              )}
              {payment === true ? (
                <Paymentlisting customerid={paramObject.id} />
              ) : (
                ""
              )}
              {statement === true ? (
                <PurchaseStatement
                  customerid={ComponentURl ? protectIdKey : paramObject.id}
                  ecomuser={ComponentURl}
                />
              ) : (
                ""
              )}

              {internalnotes ? (
                <div className={"col-lg-12 col-md-12"}>
                  <div className="card bg-white">
                    {/* <div className="row m-3">
                <div className="col-sm-12"> */}
                    <div className=" col mb-2">
                      <h5 className="card-title">Internal Notes</h5>
                      <div className="col-md-12 ">
                        <textarea
                          as="textarea"
                          className="form-control h-100 w-100"
                          defaultValue={customerdetails.InternalNotes}
                          onChange={(e) => handleCommentAndNotes(e)}
                          id="InternalNotes"
                          name="NOTES"
                          rows="10"
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
                </div> */}

                  <div className="pull-right">
                    <button
                      style={{ marginRight: "1rem" }}
                      onClick={handleSubmit1}
                      className="btn btn-sm btn-primary mb-3"
                    >
                      Save
                    </button>
                    <button
                      onClick={backtopreviouspage}
                      className="btn btn-sm btn-secondary mb-3"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}

              {comment ? (
                <div className={"col-lg-12 col-md-12"}>
                  <div className="card bg-white">
                    {/* <div className="row m-3">
                <div className="col-sm-12"> */}
                    <div className=" col mb-2">
                      <h5 className="card-title">Comments</h5>
                      <div className="col-md-12 ">
                        <textarea
                          as="textarea"
                          className="form-control h-100 w-100"
                          defaultValue={customerdetails.Comments}
                          onChange={(e) => handleCommentAndNotes(e)}
                          id="Comments"
                          name="COMMENTS"
                          rows="10"
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
                </div> */}

                  <div className="pull-right">
                    <button
                      style={{ marginRight: "1rem" }}
                      onClick={handleSubmit1}
                      className="btn btn-sm btn-primary mb-3"
                    >
                      Save
                    </button>
                    <button
                      onClick={backtopreviouspage}
                      className="btn btn-sm btn-secondary mb-3"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </>
        </div>
      </div>
      <ChangePasswordModal
        Module={"Customer"}
        employeeid={paramObject.id}
        open={PasswordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />
    </>
  );
};

export default ManageCustomer;
